import { get } from 'lodash';

const env = get(process.env, 'REACT_APP_ENV', 'dev');

export const getServiceUrl = (service) => {
	let baseUrl = 'https://apis.endvr.io';
	if (env !== 'production') {
		baseUrl = `https://apis.${env}.endvr.io`;
	}

	return `${baseUrl}/${service}`;
};
